import * as cn from "./List.scss"

import {Item} from "./Item"
import {ItemDate} from "./ItemDate"
import {Log, LogItem} from "./parseResult"
import * as React from "react"

type Props = {
    log: Log
}

let lastDate: Date

export class List extends React.PureComponent<Props> {
    render() {
        const {log} = this.props

        return (
            <ul className = {cn.component} ref = "list">
                {log.map((item: LogItem, key) => {
                    let rows: JSX.Element[] = []

                    if ((lastDate === undefined) || (lastDate.getDate() !== item.time.getDate())) {
                        lastDate = item.time

                        rows.push(<ItemDate {...{date: lastDate}}/>)
                    }

                    rows.push(<Item {...{item, key}}/>)

                    return rows
                }).toList()}
            </ul>
        )
    }
}